var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialWhtsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#25D366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_58710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57765 19.8297C6.57702 22.1823 7.17587 24.4794 8.31457 26.5041L6.46875 33.4218L13.3657 31.5655C15.2733 32.6315 17.4106 33.1901 19.5825 33.1902H19.5883C26.7583 33.1902 32.5948 27.2013 32.5979 19.8403C32.5993 16.2733 31.2472 12.9192 28.7907 10.3957C26.3346 7.87244 23.0681 6.4821 19.5877 6.48047C12.4169 6.48047 6.58072 12.469 6.57776 19.8297",
    fill: "url(#paint0_linear_1_58710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11313 19.8281C6.11239 22.2653 6.7327 24.6445 7.91201 26.7417L6 33.9074L13.1442 31.9847C15.1127 33.0863 17.329 33.6672 19.5842 33.668H19.59C27.0173 33.668 33.0635 27.4637 33.0667 19.8392C33.0679 16.144 31.6672 12.6693 29.123 10.0554C26.5784 7.44189 23.1951 6.00152 19.59 6C12.1615 6 6.11609 12.2034 6.11313 19.8281ZM10.3678 26.3805L10.101 25.9459C8.97966 24.1157 8.38779 22.0007 8.38863 19.829C8.39096 13.4915 13.4156 8.33551 19.5942 8.33551C22.5864 8.33681 25.3983 9.53408 27.5133 11.7064C29.6282 13.8789 30.792 16.7668 30.7913 19.8383C30.7885 26.1757 25.7637 31.3324 19.59 31.3324H19.5856C17.5753 31.3313 15.6038 30.7772 13.8844 29.73L13.4753 29.4809L9.23574 30.6219L10.3678 26.3805Z",
    fill: "url(#paint1_linear_1_58710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2217 14.0467C15.9695 13.4712 15.704 13.4595 15.4641 13.4494C15.2676 13.4408 15.0431 13.4414 14.8187 13.4414C14.5941 13.4414 14.2293 13.5281 13.9209 13.8738C13.6121 14.2198 12.7422 15.0559 12.7422 16.7564C12.7422 18.457 13.9489 20.1004 14.1171 20.3313C14.2855 20.5617 16.4466 24.163 19.8693 25.5485C22.7138 26.6999 23.2927 26.4709 23.91 26.4131C24.5275 26.3556 25.9024 25.5772 26.1829 24.7701C26.4636 23.9631 26.4636 23.2714 26.3795 23.1268C26.2953 22.9828 26.0707 22.8963 25.734 22.7235C25.3971 22.5506 23.7416 21.7144 23.433 21.5991C23.1243 21.4838 22.8998 21.4263 22.6752 21.7724C22.4507 22.1179 21.8058 22.8963 21.6093 23.1268C21.4129 23.3579 21.2164 23.3866 20.8797 23.2137C20.5428 23.0403 19.4583 22.6758 18.1717 21.4984C17.1707 20.5822 16.4948 19.4508 16.2984 19.1047C16.1019 18.7591 16.2773 18.5718 16.4462 18.3996C16.5975 18.2447 16.7831 17.996 16.9516 17.7942C17.1195 17.5924 17.1755 17.4483 17.2878 17.2178C17.4002 16.9871 17.3439 16.7852 17.2599 16.6124C17.1755 16.4395 16.5212 14.7301 16.2217 14.0467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_58710",
    x1: 1312.93,
    y1: 2700.61,
    x2: 1312.93,
    y2: 6.48047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_58710",
    x1: 1359.33,
    y1: 2796.74,
    x2: 1359.33,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_58710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0667,
    height: 28,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialWhtsp);
export default __webpack_public_path__ + "static/media/social-whtsp.133285ca6295c95aeb0f7ad68fa4a2b5.svg";
export { ForwardRef as ReactComponent };